import { getLanguage } from './languageStore';
/**
 * Declares the labels a package owns and returns the accessor its components
 * read them through.
 *
 * The package imports its own translation files and keeps them; nothing is
 * handed to a central store, so no package can reach another package's strings
 * and there is no registration to order against application startup.
 *
 * ```ts
 * import englishLabels from './translations/en.json';
 * import polishLabels from './translations/pl.json';
 *
 * export const labels = defineLabels<Labels>({ en: englishLabels, pl: polishLabels });
 * ```
 */
export function defineLabels(labelsByLanguage) {
    return () => labelsByLanguage[getLanguage()];
}
